const strDateTimeFormat = strDateTime => {
  let dt = strDateTime.split("T");
  let d = "";
  let t = "";
  if (dt.length > 1) {
    d = dt[0].split("-").reverse().join(".");
    t = dt[1];
  }

  return `${d} ${t}`;
};

export { strDateTimeFormat };
